import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import { StorageService } from 'src/app/services/storage.service'
import { PessoaService } from 'src/app/services/pessoa.service'
import { Pessoa, EnumTipoPessoa, EnumPapelPessoa, ListaEnumTipoFornecedor, EnumTipoFornecedor } from 'src/app/classes/Pessoa'
import cep from 'cep-promise'

@Component({
  selector: 'app-forms-fornecedor',
  templateUrl: './forms-fornecedor.component.html',
  styleUrls: ['./forms-fornecedor.component.scss']
})
export class FormsFornecedorComponent implements OnInit {

  @ViewChild('Modal', { static: false }) modal: UiModalComponent
  @ViewChild('formulario', { static: false }) formulario!: NgForm
  @Output() finalizarSave: EventEmitter<Pessoa> = new EventEmitter()

  isSubmit: boolean = false
  fornecedor: Pessoa = new Pessoa()
  carregando: boolean = false
  carregandoDadosCNPJ: boolean = false
  mascaraCpfCnpj: string = '00.000.000/0000-00'

  tiposFornecedor = ListaEnumTipoFornecedor
  paises: string[] = ['Brasil'] // TODO: Implementar busca de países quando necessário

  // tiposFornecedorSelecionados: EnumTipoFornecedor[] = []

  constructor(
    private utils: UtilsService,
    private pessoaService: PessoaService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.fornecedor.Ativo = true
  }

  abrirModal(fornecedor: Pessoa = null): void {
    // TODO: Implementar verificação de permissão quando necessário
    // if(fornecedor == null && !this.utils.verificarPermissaoUsuario('IncluirFornecedor'))
    //   return
    console.debug('fornecedor: ', fornecedor)
    if (fornecedor != null){
      this.fornecedor = Object.assign(new Pessoa(), fornecedor)
      // Garantir que os campos de endereço estejam inicializados
      if (!this.fornecedor.Pais) {
        this.fornecedor.Pais = 'Brasil'
      }
    }
    else {
      this.fornecedor = new Pessoa()
      this.fornecedor.Ativo = true
      this.fornecedor.Pais = 'Brasil'
    }
    console.debug('fornecedor 2: ', this.fornecedor)

    this.fornecedor.Papel = EnumPapelPessoa.Fornecedor
    this.modal.show()
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
    if (this.formulario) {
      this.formulario.resetForm()
    }
  }

  isCampoInvalido(campo: NgModel): boolean {
    if (!campo) {
      return false
    }
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    )
  }

  buscarCNPJ(): void {

    if(this.fornecedor.CpfCnpj.replace(/\D/g, '').length === 14){
      this.fornecedor.Tipo = EnumTipoPessoa.Juridica
    }
    else if(this.fornecedor.CpfCnpj.replace(/\D/g, '').length === 11){
      this.fornecedor.Tipo = EnumTipoPessoa.Fisica
    }
    else{
      this.utils.handleWarning('Por favor, insira um CPF/CNPJ válido.')
    }

    if(this.fornecedor.Tipo === EnumTipoPessoa.Juridica){
      this.carregandoDadosCNPJ = true
      this.pessoaService.getCNPJ(this.fornecedor.CpfCnpj.replace(/\D/g, ''))
      .subscribe(res => {
        if(res && res.CpfCnpj){
          this.fornecedor.RazaoSocial = res.RazaoSocial || this.fornecedor.RazaoSocial
          this.fornecedor.NomeFantasia = res.NomeFantasia || this.fornecedor.NomeFantasia
          this.fornecedor.inscricaoEstadual = res.inscricaoEstadual || this.fornecedor.inscricaoEstadual
          // Preencher endereço se vier da API
          if(res.Logradouro) {
            this.fornecedor.Logradouro = res.Logradouro
            this.fornecedor.Bairro = res.Bairro || ''
            this.fornecedor.Cidade = res.Cidade || ''
            this.fornecedor.Estado = res.Estado || ''
            this.fornecedor.Cep = res.Cep || ''
            this.fornecedor.Pais = res.Pais || 'Brasil'
          } else if(res.Enderecos && res.Enderecos.length > 0){
            // Fallback para estrutura antiga com array de endereços
            const enderecoPrincipal = res.Enderecos[0]
            this.fornecedor.Cep = enderecoPrincipal.CEP || ''
            this.fornecedor.Estado = enderecoPrincipal.UF || ''
            this.fornecedor.Cidade = enderecoPrincipal.Cidade || ''
            this.fornecedor.Bairro = enderecoPrincipal.Bairro || ''
            this.fornecedor.Logradouro = enderecoPrincipal.Logradouro || ''
            this.fornecedor.Pais = 'Brasil'
          }
        }
        this.carregandoDadosCNPJ = false
      }, err => {
        this.utils.getErro(err)
        this.carregandoDadosCNPJ = false
      })
    }
  }

  buscarCEP(): void {
    if(this.fornecedor.Cep && this.fornecedor.Cep.replace(/\D/g, '').length === 8){
      cep(this.fornecedor.Cep.replace(/\D/g, ''))
      .then(res => {
        this.fornecedor.Estado = res.state || ''
        this.fornecedor.Cidade = res.city || ''
        this.fornecedor.Bairro = res.neighborhood || ''
        this.fornecedor.Logradouro = res.street || ''
        if (!this.fornecedor.Pais) {
          this.fornecedor.Pais = 'Brasil'
        }
      })
      .catch(err => {
        console.error('Erro ao buscar CEP:', err)
      })
    }
  }

  onTipoFornecedorChange(event: any): void {
    if(this.fornecedor.ListaTipoFornecedor && this.fornecedor.ListaTipoFornecedor.length > 0)
      this.fornecedor.TipoFornecedor = this.fornecedor.ListaTipoFornecedor.join(',')
    else
      this.fornecedor.TipoFornecedor = ''
  }

  save(): void {
    console.debug(this.fornecedor)
    this.carregando = true

    if (!this.validarForm()) return

    // Garantir que o país esteja preenchido
    if (!this.fornecedor.Pais) {
      this.fornecedor.Pais = 'Brasil'
    }

    if (this.fornecedor.Id) {
      this.pessoaService
        .putFornecedor(this.fornecedor.Id, this.fornecedor)
        .subscribe(
          (res) => {
            this.finalizarSaveRequestSuccess(
              'Fornecedor alterado com sucesso!',
            )
          },
          (err) => {
            this.finalizarRequestError(err)
          },
        )
    } else {
      this.pessoaService.postFornecedor(this.fornecedor).subscribe(
        (res) => {
          const fornecedorRetornado = res ? Object.assign(new Pessoa(), res) : null;
          this.finalizarSaveRequestSuccess(
            'Fornecedor cadastrado com sucesso!',
            fornecedorRetornado
          )
        },
        (err) => {
          this.finalizarRequestError(err)
        },
      )
    }
  }

  validarForm(): boolean {
    if (this.formulario.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string, fornecedor?: Pessoa): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit(fornecedor)
    this.fecharModal()
  }

  finalizarRequestError(error: any): void {
    this.utils.getErro(error)
    this.carregando = false
  }
}
